<template>
  <section
    class="component-cb51a9b2"
    resmed-component-name="cpap equipment: the complete system"
  >
    <div class="component">
      <div class="steps">
        <div
          v-for="(item, key) in acf.step"
          class="embed-responsive step"
          v-bind:class="{
            [`step-${item.number}`]: true,
            'is-active': active === `step-${item.number}`,
            'embed-responsive-16by9':
              $root.mode === 'lg' || $root.mode === 'xl',
            'embed-responsive-768by732':
              $root.mode === 'sm' || $root.mode === 'md',
            'embed-responsive-360by658': $root.mode === 'xs',
          }"
          v-bind:data-step="item.number"
        >
          <video
            muted
            playsinline
            autobuffer
            autoloop
            loop
            autoplay
            :key="componentKey"
          >
            <source v-bind:src="`${item.background[mode]}`" />
          </video>

          <div class="embed-responsive-item">
            <div class="container px-xs-sm-2">
              <!-- step 02 to 05 -->
              <template v-if="key >= 1">
                <div class="row">
                  <div class="col-lg-4 col-xl-4 offset-xl-2">
                    <span class="step-number">{{ item.number }}</span>
                    <h1 v-html="item.headline"></h1>
                  </div>
                </div>

                <div class="row">
                  <div class="d-none d-xl-block col-xl-2">
                    <ul>
                      <li v-for="item in acf.step">
                        <a href="#" v-on:click.prevent="step(item.number)"
                          ><span>{{ item.number }}</span> {{ item.title }}</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-7 col-lg-5 col-xl-4">
                    <div class="content" v-html="item.content"></div>

                    <div class="resources" v-if="key + 1 === 5">
                      <a
                        v-if="acf['apple-app-store']"
                        target="_blank"
                        v-bind:href="acf['apple-app-store']"
                        class="btn apple-store d-block text-hide mr-3"
                        >Download on the App Store</a
                      >
                      <a
                        v-if="acf['google-play']"
                        target="_blank"
                        v-bind:href="acf['google-play']"
                        class="btn google-play d-block text-hide"
                        >Get it on Google Play</a
                      >
                    </div>
                  </div>
                </div>
              </template>

              <!-- step 01 -->
              <template v-else>
                <div class="row align-items-end">
                  <div class="col-lg-4">
                    <span class="step-number">{{ item.number }}</span>
                    <h1 v-html="item.headline"></h1>
                  </div>
                  <div class="col-lg-6 offset-lg-1">
                    <div class="content" v-html="item.content"></div>
                    <span class="d-none d-md-inline-block scroll-to-learn-more"
                      >Scroll to learn more</span
                    >
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inView from "in-view"; // https://github.com/camwiegert/in-view
import { scroll } from "../../mixins/index";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import backgroundVideo from "../shared-support/background-video";

export default {
  name: "component-cb51a9b2", // cpap equipment: the complete system
  props: ["acf"],
  components: {
    backgroundVideo,
  },
  data() {
    return {
      video: "", // video file
      componentKey: 0,
      active: "",
      mode: "",
      section: 1,
      bypass: true,
      prevent: false, // prevent auto-scroll
    };
  },
  mixins: [scroll],
  watch: {
    active(val) {
      if (val === "step-01") {
        this.scroll({
          to: `html`,
          duration: 1200,
          callback: () => {
            setTimeout(() => {
              this.bypass = true;
            }, 100);
          },
        });
      } else {
        this.scroll({
          to: `.component-cb51a9b2 .${val}`,
          duration: 1200,
          callback: () => {
            setTimeout(() => {
              this.bypass = true;
            }, 100);
          },
        });
      }
    },
    "$root.mode": {
      handler(val) {
        if (val === "lg" || val === "xl") {
          this.mode = "desktop";
        }

        if (val === "sm" || val === "md") {
          this.mode = "tablet";
        }

        if (val === "xs") {
          this.mode = "mobile";
        }
      },
      immediate: true,
    },
  },
  methods: {
    step(arg) {
      this.bypass = false;
      this.section = parseInt(arg);

      this.active = `step-${arg}`;
    },
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
        aprimo_url: arg[2] || null,
        aprimo_subtitle: arg[3] || null
      });
    },
    throttle: throttle(function (direction) {
      this.bypass = false;

      if (this.prevent) {
        this.bypass = true;
        return;
      }

      if (direction === "down") {
        if (this.section >= 5) {
          this.section = 6; // allow it scroll further down. (6) is not a section and it will return undefined
          this.bypass = true; // no callback, switch bypas
        } else {
          this.section += 1;
        }
      } else {
        this.section -= 1;
      }

      this.scroll({
        to: `.component-cb51a9b2 .step-0${this.section}`,
        duration: 800,
        callback: () => {
          setTimeout(() => {
            this.bypass = true;
          }, 100);
        },
      });
    }, 200),
  },
  mounted() {
    inView.threshold(1);

    // component: “keep exploring”
    // explore_card_3col_icon-line_graphic_text_link
    inView(".component-bd673c97")
      .on("enter", () => {
        this.prevent = true;
      })
      .on("exit", () => {
        this.prevent = false;
      });

    let position = 0;

    $(window).on("scroll", () => {
      return; // temporarily disable “snap-scroll”

      let direction =
        document.body.getBoundingClientRect().top > position ? "up" : "down";
      position = document.body.getBoundingClientRect().top; // save new position for next iteration

      if (!this.bypass) {
        return;
      }

      this.throttle(direction);
    });
  },
  created() {
    bus.$on("mode", (arr) => {
      // md <--> lg
      if (
        (arr[1] === "lg" && arr[0] === "md") ||
        (arr[0] === "lg" && arr[1] === "md")
      ) {
        this.componentKey += 1;
      }

      // xs <--> sm
      if (
        (arr[1] === "sm" && arr[0] === "xs") ||
        (arr[0] === "sm" && arr[1] === "xs")
      ) {
        this.componentKey += 1;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cb51a9b2 {
  // -->
}

.component {
  .embed-responsive-item {
    display: flex;
    align-items: flex-end;

    > .container {
      padding-bottom: 3rem;

      @media (min-width: 768px) {
        padding-bottom: 4rem;
      }

      @media (min-width: 992px) {
        padding-bottom: 3rem;
      }

      @media (min-width: 1200px) {
        padding-bottom: 5rem;
      }
    }
  }

  .steps {
    // height: 100vh;
    // overflow-y: scroll;
    // scroll-snap-type: y mandatory;
  }

  .step {
    background-color: $cc-resmed-black;
    color: $cc-resmed-white;

    // scroll-snap-align: start;

    .step-number {
      display: block;
      margin-bottom: 1.825rem;
      @extend %body-normal-bold;
    }

    .scroll-to-learn-more {
      margin-top: 3rem;
      display: inline-block;
      @extend %body-small-bold;
    }
  }

  // steps 1-5
  $value: 0;
  @for $i from 1 through 5 {
    // .step-0#{$i} {
    //     &.is-active {
    //         li:nth-child(#{$i}) {
    //             a {
    //                 opacity: 1 !important;
    //                 cursor: default;
    //             }
    //         }
    //     }
    // }

    .step-0#{$i} {
      li:nth-child(#{$i}) {
        a {
          opacity: 1 !important;
          cursor: default;
        }
      }
    }
  }

  h1 {
    margin-bottom: 1rem;
  }

  li {
    list-style: none;
    margin-bottom: 1.825rem;
    @extend %body-small-bold;

    a {
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }

  a {
    color: $cc-resmed-white;
    transition: all 0.5s;

    &:hover {
      opacity: 0.5;
    }

    > span {
      margin-right: 0.5rem;
    }
  }
}

.resources {
  display: flex;
  align-items: center;
  margin-top: 3rem;
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cb51a9b2 {
  .step {
    p {
      @media (min-width: 768px) {
        font-size: 1.063rem;
        line-height: 1.33;
      }
    }

    h1 {
      position: relative;
      @extend %eyebrow-left;
      &:before {
        background-color: $cc-resmed-white;
      }

      > span {
        display: block;
        margin-bottom: 0.5rem;
        @extend %body-small-bold;
        letter-spacing: normal;
        font-size: 1.125rem;
      }
    }
  }

  .step-01 {
    h1 {
      @extend %display;
      line-height: 0.96;

      @media (min-width: 992px) {
        margin-bottom: 0;
      }
    }
  }
}
</style>